import { render, staticRenderFns } from "./l3.vue?vue&type=template&id=73fd4564&scoped=true&"
import script from "./l3.vue?vue&type=script&lang=js&"
export * from "./l3.vue?vue&type=script&lang=js&"
import style0 from "./l3.vue?vue&type=style&index=0&id=73fd4564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd4564",
  null
  
)

export default component.exports